<template>
	<header id="header">

		<div class="header-content" id="header-content">

			<div class="header-menu">
				<b-navbar toggleable="lg" type="light" variant="light">
					<div class="container oversized-container">
						<b-navbar-brand to="/">
							<img src="public/images/logo.svg" alt="BlackFon">
						</b-navbar-brand>

						<b-navbar-toggle ref="bNavbarToggle" target="nav-collapse">
							<i class="fas fa-bars bar-icon"></i>
						</b-navbar-toggle>

						<b-collapse id="nav-collapse" is-nav>
							<b-navbar-nav class="ml-auto">

								<li class="nav-item highlight">
									<a class="nav-link" @click="reloadContrataYa">
										{{ contrataYa.generalTitle }}
									</a>
								</li>

								<li class="nav-item">
									<router-link class="nav-link" to="/cobertura">Cobertura</router-link>
								</li>

								<li class="nav-item">
									<router-link class="nav-link" to="/portabilidad">Portabilidad</router-link>
									<!-- <router-link class="nav-link" to="/#h-portabilidad" v-scroll-to="'#h-portabilidad'">Portabilidad</router-link> -->
								</li>
								<li class="nav-item">
									<router-link class="nav-link" to="/equipos">Equipos</router-link>
									<!-- <router-link class="nav-link" to="/#h-portabilidad" v-scroll-to="'#h-portabilidad'">Portabilidad</router-link> -->
								</li>
								<li class="nav-item">
									<router-link class="nav-link" to="/compatibilidad">Compatibilidad</router-link>
								</li>

								<b-nav-item-dropdown right v-if="displayBlackFonContent">
									<template #button-content>
										<span>BlackFon</span>
									</template>
									<b-dropdown-item to="/sucursales">Sucursales y contactos</b-dropdown-item>
									<b-dropdown-item to="/pages">Noticias y promociones</b-dropdown-item>
									<b-dropdown-item to="/empresa">Empresa</b-dropdown-item>
									<b-dropdown-item to="/glosario">Glosario</b-dropdown-item>
									<b-dropdown-item to="/preguntas-frecuentes">Preguntas frecuentes</b-dropdown-item>
									<b-dropdown-item to="/contacto">Contáctanos</b-dropdown-item>
								</b-nav-item-dropdown>

								<b-button-group class="my-cart-account-buttons" size="sm">
									<b-button @click="triggerMyCart" variant="info">
										<i class="fas fa-shopping-cart"></i>
										<span class="d-lg-none d-xl-inline">Mi carrito</span>
									</b-button>
									<b-button @click="triggerMyAccount" variant="primary">
										<i class="fas fa-user"></i>
										<span class="d-lg-none d-xl-inline" v-if="isLogged">Mi cuenta</span>
										<span class="d-lg-none d-xl-inline" v-else>Acceder</span>
									</b-button>
								</b-button-group>

								<li class="nav-item no-hoverline"></li>
							</b-navbar-nav>
						</b-collapse>
					</div>
				</b-navbar>
			</div>


			<div class="my-cart-account-buttons-small" size="sm">
				<div class="btn-like text-nowrap highlightOnHover" @click="triggerMyCart" variant="info">
					<i class="fas fa-shopping-cart"></i> Mi Carrito
				</div>
				<div class="btn-like text-primary text-nowrap highlightOnHover" @click="triggerMyAccount"
					variant="primary">
					<i class="fas fa-user"></i> Mi Cuenta
				</div>
			</div>

			<div class="header-buttons">
				<a class="t-250 _btn" href="#" @click="portalCautivo">
					<h1 class="ml12">Recarga aquí</h1>
				</a>
			</div>

		</div>

		<acceso-cuenta-modal ref="accesoCuentaModal" />

	</header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import contrataYa from '@/js/components/page/daniel/contrata-ya/contrataYa'
import accesoCuentaModal from '@/js/components/page/daniel/contrata-ya/acceso-cuenta-modal'
import { pcURI, portalCautivo } from '@/js/apiConfig'

export default {

	data() {
		return {
			contrataYa,
			showBtn: false
		}
	},

	props: {
		pcURI: {
			type: String,
			default: () => pcURI
		},
		displayBlackFonContent: {
			type: Boolean,
			default: false
		},
		myCarPath: {
			type: String,
			default: '/cart'
		},
		myAccountPath: {
			type: String,
			default: '/usuario/numeros'
		}
	},

	components: {
		accesoCuentaModal
	},

	computed: {
		...mapGetters(['isLogged', 'getUser'])
	},

	methods: {
		...mapActions(['authAsk4LogOut']),
		portalCautivo,
		triggerMyCart() {
			// redirect
			if (this.$route.path != this.myCarPath)
				this.$router.push(this.myCarPath);
			this.toggleNavBarIfItsOpen()
		},
		triggerMyAccount() {
			// try {

			// redirect
			if (this.isLogged && this.$route.path != this.myAccountPath)
				this.$router.push(this.myAccountPath);

			else if (!this.isLogged)
				this.$refs.accesoCuentaModal.show();

			// } catch (e) {
			// console.info('Error while navigating to contrata-ya:', e);
			// }
			this.toggleNavBarIfItsOpen()
		},
		toggleNavBarIfItsOpen() {
			if (this.$refs.bNavbarToggle && this.$refs.bNavbarToggle.$el && this.$refs.bNavbarToggle.toggleState == true)
				this.$refs.bNavbarToggle.$el.click();
		},
		reloadContrataYa() {
			try {
				this.$router.replace({ name: 'contrata-ya', query: {} });
			} catch (error) {
				console.info('Error while navigating to contrata-ya:', error);
			}
		},
		async tryToLogout() {
			await this.authAsk4LogOut()
			setTimeout(() => {
				if (!this.isLogged)
					this.$router.replace('/')
			}, 150)
		},
		handleAction(event) {
			var scrollY = window.scrollY;
			var headerHeight = document.getElementById("header-content").offsetHeight;

			document.getElementById("header").style.height = headerHeight + 'px';

			if (scrollY >= headerHeight) {
				this.showBtn = true;
			}
			else {
				this.showBtn = false;
			}
		},
		tryAnimate() {
			// Wrap every letter in a span
			var textWrapper = document.querySelector('.ml12');
			textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

			anime.timeline({ loop: true })
				.add({
					targets: '.ml12 .letter',
					translateX: [40, 0],
					translateZ: 0,
					opacity: [0, 1],
					easing: "easeOutExpo",
					duration: 1200,
					delay: (el, i) => 500 + 30 * i
				}).add({
					targets: '.ml12 .letter',
					translateX: [0, -30],
					opacity: [1, 0],
					easing: "easeInExpo",
					duration: 1100,
					delay: (el, i) => 100 + 30 * i
				});
		}
	},

	mounted() {
		this.handleAction();
		this.tryAnimate()
	},

	created() {
		window.addEventListener('scroll', this.handleAction);
		window.addEventListener('resize', this.handleAction);
	},

	destroyed() {
		window.removeEventListener('scroll', this.handleAction);
		window.removeEventListener('resize', this.handleAction);
	},
}
</script>

<style lang="less">
.ml12 {
	font-weight: 200;
	font-size: 1.0em;
	text-transform: uppercase;
	letter-spacing: 0.5em;

	.letter {
		display: inline-block;
		line-height: 1em;
	}
}
</style>

<style lang="scss">
@import '@/sass/utils/variables.scss'; // Variables for the application

.my-cart-account-buttons {
	margin-left: 1em;
	.btn-sm,
	.btn-group-sm>.btn {
		border-radius: 0;
	}

	&,
	&-small {
		span {
			text-transform: uppercase !important;
		}
	}

	@media screen and (max-width: 991px) {
		display: none;
	}
}

.my-cart-account-buttons-small {
	flex: 1;
	display: inline-flex;
	justify-content: flex-end;
	border-radius: none;
	color: $white;
	width: 100%;
	background-color: $black;

	.btn-like {
		flex: 1;
		text-align: center;
		padding: 0.5em;
		border: $primary-dark-border;
		border-bottom: 0;
	}

	@media screen and (min-width: 992px) {
		display: none;
	}
}

.highlight {
	a {
		font-weight: bold;

		&:hover {
			color: $accent !important;
			// color: $secondary !important;
		}
	}

	&:hover {
		a {
			color: $accent !important;
			// color: $secondary !important;
		}
	}
}
</style>